import React from 'react';
import { FormattedMessage } from 'react-intl';

const PasswordRecoverConfirmation = ({ email, onSendAgainClick }) => {
  const onClick = (ev) => {
    ev.preventDefault();
    ev.stopPropagation();
    onSendAgainClick();
  };
  return (
    <div>
      <div className="modal-title modal-section text-center divider">
        <h1>
          <FormattedMessage
            id="passwordRecoverConfirmation.title"
            defaultMessage="Check email"
          />
        </h1>
        <p className="text-muted">
          <FormattedMessage
            id="passwordRecoverConfirmation.instructions"
            defaultMessage="To set a new password, click the link in the email we just sent to:"
          />
        </p>
      </div>

      <div className="modal-section text-center">
        <h2>{email}</h2>
      </div>
      <p className="text-muted text-center">
        <FormattedMessage
          id="passwordRecoverConfirmation.troubleShoot"
          defaultMessage="Didn't receive the email? {link}"
          values={{ link: (
            <a href="/password-reset" onClick={onClick}>
              <FormattedMessage
                id="passwordRecoverConfirmation.sendAgain"
                defaultMessage="Send again"
              />
            </a>
          )}}
        />
      </p>
    </div>
  );
};

export default PasswordRecoverConfirmation;



// WEBPACK FOOTER //
// ./src/desktop/components/password-reset/confirmation.js